// Status display helpers for billing invoices.
// `displayStatus` derives an overdue-aware label from the underlying
// `status` enum + `issuedAt` / `lastRemindedAt` timestamps. The 30-day
// threshold matches what we configured in the model previously.

const OVERDUE_DAYS = 30

function daysBetween (laterIso, earlierIso) {
  return Math.floor(
    (new Date(laterIso).getTime() - new Date(earlierIso).getTime()) / (24 * 3600 * 1000)
  )
}

export function displayStatus (inv) {
  if (!inv) return 'draft'
  if (['paid', 'credited', 'void', 'draft', 'sending'].includes(inv.status)) {
    return inv.status
  }

  const now = new Date().toISOString()
  if (inv.status === 'issued') {
    const days = inv.issuedAt ? daysBetween(now, inv.issuedAt) : 0
    return days > OVERDUE_DAYS ? 'overdue' : 'issued'
  }
  if (inv.status === 'reminded') {
    const days = inv.lastRemindedAt ? daysBetween(now, inv.lastRemindedAt) : 0
    return days > OVERDUE_DAYS ? 'overdue_reminded' : 'reminded'
  }
  return inv.status
}

const COLOR_BY_STATUS = {
  draft:            'grey',
  sending:          'yellow',
  issued:           'blue',
  reminded:         'teal',
  overdue:          'orange',
  overdue_reminded: 'red',
  paid:             'green',
  credited:         'orange',
  void:             'black'
}

export function statusColor (status) {
  return COLOR_BY_STATUS[status] || 'grey'
}
